import React, { Component, useRef } from 'react';
import PropTypes from 'prop-types';
import './table-header-row.scss';
import GeckoTableHeaderCell from '../table-header-cell/table-header-cell.jsx';
import {
  GeckoTableCellsModel,
  GeckoPaginationModel,
  GeckoTableMassActionModel,
} from '../../../models';

const MassActionHeader = ({ massAction, rows }) => {
  const checkboxRef = useRef(null);
  const isChecked = rows.every((row, index) => {
    return massAction.isRowSelected(row, index);
  });
  const onChange = (event) => {
    massAction.onHeaderSelected(rows);
  };
  const onHeaderClick = (event) => {
    if (event.target === checkboxRef.current) {
      return;
    }
    checkboxRef.current.focus();
    checkboxRef.current.click();
  };
  return (
    <th onClick={onHeaderClick} aria-label="Mass Action">
      <input
        ref={checkboxRef}
        type="checkbox"
        checked={isChecked}
        onChange={onChange}
      />
    </th>
  );
};

class GeckoTableHeaderRow extends Component {
  renderMassAction() {
    if (!this.props.massAction) {
      return null;
    }
    return (
      <MassActionHeader
        massAction={this.props.massAction}
        rows={this.props.rows}
      />
    );
  }

  renderCols() {
    return this.props.cols.map((col, i) => (
      <GeckoTableHeaderCell
        col={col}
        pagination={this.props.pagination}
        key={i}
      />
    ));
  }

  render() {
    return (
      <thead>
        <tr>
          {this.renderMassAction()}
          {this.renderCols()}
        </tr>
      </thead>
    );
  }
}

GeckoTableHeaderRow.defaultProps = {
  cols: [],
  pagination: {},
};

GeckoTableHeaderRow.propTypes = {
  cols: GeckoTableCellsModel.isRequired,
  pagination: PropTypes.shape(GeckoPaginationModel),
  massAction: GeckoTableMassActionModel,
};

export default GeckoTableHeaderRow;
